export const isRecordLabelNameValid = (rlName: string) => {
  return !['self-released', 'independent', 'no label'].includes(
    rlName.trim().toLowerCase()
  );
};
